import { Injectable } from "@angular/core";

@Injectable()
export class TimeFormatService {
  private MINUTE = 60;
  private HOUR = 3600;
  private DAY = 86400;
  private MONTH = 2629744;
  private YEAR = 31556926;

  // Takes a date object (or any value that can be passed to the new Date()
  // constructor) representing a time interval and returns a string
  // representation of how long ago that was.
  public timeFor(interval: any) {
    if (interval == null) {
      return;
    }
    let formattedInterval: any;
    let intervalSuffix: any;
    const intervalDate = new Date(interval);
    const intervalSecs = intervalDate.getTime() / 1000;
    if (intervalSecs === 0 || isNaN(intervalSecs)) {
      return;
    } else if (intervalSecs < this.MINUTE) {
      formattedInterval = intervalSecs;
      intervalSuffix = "second";
    } else if (intervalSecs < this.HOUR) {
      formattedInterval = Math.abs(intervalSecs / this.MINUTE);
      intervalSuffix = "minute";
    } else if (intervalSecs < this.DAY) {
      formattedInterval = Math.abs(intervalSecs / this.HOUR);
      intervalSuffix = "hour";
    } else if (intervalSecs < this.MONTH) {
      formattedInterval = Math.abs(intervalSecs / this.DAY);
      intervalSuffix = "day";
    } else if (intervalSecs < this.YEAR) {
      formattedInterval = Math.abs(intervalSecs / this.MONTH);
      intervalSuffix = "month";
    } else if (intervalSecs > this.YEAR) {
      formattedInterval = Math.abs(intervalSecs / this.MONTH);
      intervalSuffix = "month";
    }

    formattedInterval = Math.round(formattedInterval);
    if (formattedInterval !== 1) {
      intervalSuffix = intervalSuffix + "s";
    }

    return `${formattedInterval} ${intervalSuffix}`;
  }
}
